"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cpFolderCreateApi = cpFolderCreateApi;
exports.cpFolderDeleteApi = cpFolderDeleteApi;
exports.cpFolderDetailsApi = cpFolderDetailsApi;
exports.cpFolderDetailsHtmlApi = cpFolderDetailsHtmlApi;
exports.cpFolderEditApi = cpFolderEditApi;
exports.cpFolderGetApi = cpFolderGetApi;
exports.cpFolderGetallApi = cpFolderGetallApi;
exports.cpFolderGetallInitialApi = cpFolderGetallInitialApi;
exports.cpFolderGetallcpRootNodeApi = cpFolderGetallcpRootNodeApi;
exports.cpFolderUpdateApi = cpFolderUpdateApi;
exports.cpPreviewImageApi = cpPreviewImageApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function cpFolderCreateApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.addFolder), params);
}

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */

function cpFolderGetApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.getFolderList), params);
}

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function cpFolderUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.updateFolder), params);
}

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function cpFolderGetallApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.getAllFolder), params);
}

/**
 * cpFolderGetallInitialApi
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function cpFolderGetallInitialApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.getAllInitialfolder), params);
}

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function cpFolderGetallcpRootNodeApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.getAllCpRootNode), params);
}

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data..
 */
function cpFolderDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.deleteCpFolder), params);
}

/**
 * details
 * @param payload
 * @returns api response
 * @description this function used to get details.
 */
function cpFolderDetailsApi(params) {
  return generateResponse(params);
}

/**
 * details
 * @param payload
 * @returns api response
 * @description this function used to get details.
 */
function cpFolderEditApi(params) {
  var _sessionStorage;
  var headersConfig = JSON === null || JSON === void 0 ? void 0 : JSON.parse((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("headersConfigLock"));
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.cpFolderEdit), params, headersConfig);
}

/**
 * details
 * @param payload
 * @returns api response
 * @description this function used to get details html.
 */
function cpFolderDetailsHtmlApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.cpFolderDetailsHtml), params);
}

/**
 * details
 * @param payload
 * @returns api response
 * @description this function used to get details.
 */
function cpPreviewImageApi(params) {
  return generateResponse(params);
}
var generateResponse = function generateResponse(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpFolder.cpFolderDetails), params);
};